import { VideoType } from '@/libs/types'
import React from 'react'
import YoutubeEmbeded from './YoutubeEmbeded'
interface SectionVideoProps {
    video: VideoType
}
const SectionVideo: React.FC<SectionVideoProps> = ({ video }) => {
    return (
        <div className="row justify-content-center my-5">
            <div className="col-md-10 col-12">
                <YoutubeEmbeded url={video.link} />
            </div>
        </div>
    )
}

export default SectionVideo